import { useState, useEffect } from "react";
import ApiService from "../services/httpService";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { notification } from "antd";

const Login = () => {
  const [eye, setEye] = useState(true);

  const history = useHistory();
  const [
    formHide,
    // setFromHide
  ] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      history.push("/dashboard");
    }
  }, []);

  const validateForm = () => {
    const validationErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      validationErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      validationErrors.email = "Invalid email format";
    }

    if (!password.trim()) {
      validationErrors.password = "Password is required";
    } else if (password.length < 6 || password.length > 20) {
      validationErrors.password =
        "Password must be between 6 and 20 characters";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const validateField = (field, value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let error = {};

    switch (field) {
      case "email":
        if (!value.trim()) {
          error.email = "Email is required";
        } else if (!emailRegex.test(value)) {
          error.email = "Invalid email format";
        }
        break;

      case "otp":
        if (!value.trim()) {
          error.otp = "OTP is required";
        } else if (value.length !== 6 || isNaN(value)) {
          error.otp = "OTP must be a 6-digit number";
        }
        break;

      default:
        break;
    }

    setErrors(error);
    return Object.keys(error).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const LoginUser = await ApiService.getPublic(
        `api/CenPilot/Login?Mail=${email}`
      );

      console.log("Login User", LoginUser);
      console.log("Login User", LoginUser[0]);

      if (LoginUser.message !== "Invalid Mail") {
        if (LoginUser[0].Password === password) {
          const browserId = generateBrowserId();
          console.log("User's browser ID:", browserId);
          const FullCode = {
            ID: LoginUser[0].ID,
            DeviceID: browserId,
          };
          console.log("Full Code", FullCode);
          const UpdateTokenDevice = await ApiService.postPublic(
            `api/CenPilot/UpdateDeviceID`,
            FullCode
          );

          console.log("Update Token Device", UpdateTokenDevice);
          localStorage.setItem("Browser_ID", browserId);
          localStorage.setItem("user", JSON.stringify(LoginUser[0]));
          localStorage.setItem("user_id", LoginUser[0].ID);
          localStorage.setItem("Cen_Auth_Provider_ID", LoginUser[0].ID);
          notification.success({
            message: "Login Successful",
            description: "You have successfully logged in.",
          });
          history.push("/");
        } else {
          notification.error({
            message: "Error",
            description: "Invalid password",
          });
        }
      } else {
        notification.error({
          message: "Error",
          description: "Invalid email",
        });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Error",
        description: "Invalid email or password",
      });
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    console.log("Email submission", email);
    if (!validateField("email", email)) return;
    setIsSubmitting(true);
    try {
      const response = await ApiService.getPublic(
        `api/CenPilot/Login?Mail=${email}`
      );

      console.log("response", response);

      if (response.message !== "Invalid Mail") {
        // Generate and send OTP via WhatsApp
        const otp = Math.floor(100000 + Math.random() * 900000).toString();
        console.log("otp", otp);
        console.log("response.Data.mobile", response.data.Phone);
        console.log("response.Data.user_name", response.data.Name);

        setGeneratedOtp(otp);
        // setInputEmail(email);

        // const Data = await Http.request(
        //   `https://app.tendigit.in/api/sendtemplate.php?LicenseNumber=62390570079&APIKey=QxjBpmLDoIMduW1YCPsfXnJZe&Contact=91${response.Data.mobile}&Template=code&Param=${response.Data.user_name},${otp}`
        // );
        const Data = await fetch(
          `https://app.tendigit.in/api/sendtemplate.php?LicenseNumber=62390570079&APIKey=QxjBpmLDoIMduW1YCPsfXnJZe&Contact=91${response.data.Phone}&Template=code&Param=${response.data.Name},${otp}`,
          {
            mode: "no-cors",
          }
        );
        console.log("Data", Data);
        if (Data.status == 0) {
          localStorage.setItem("user", JSON.stringify(response.Data));
          localStorage.setItem("user_id", response.data.ID);
          console.log("save all data in localStorage");
          setOtpSent(true);
          notification.success({
            message: "OTP sent via WhatsApp",
            description: "Please check your WhatsApp for the OTP.",
          });
        } else {
          notification.error({
            message: "Error",
            description: "Failed to send OTP via WhatsApp",
          });
        }
      } else {
        notification.error({
          message: "Error",
          description: "Invalid email",
        });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Error",
        description: "Failed to send OTP via WhatsApp" + error,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  function getBrowserInfo() {
    return {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      screenResolution: window.screen.width + "x" + window.screen.height,
      colorDepth: window.screen.colorDepth,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      touchSupport: navigator.maxTouchPoints > 0,
      hardwareConcurrency: navigator.hardwareConcurrency,
      deviceMemory: navigator.deviceMemory || "unknown",
    };
  }

  const generateBrowserId = () => {
    const info = getBrowserInfo();
    const infoString = JSON.stringify(info);
    let hash = 0;

    for (let i = 0; i < infoString.length; i++) {
      const char = infoString.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0;
    }

    const timestamp = Date.now().toString(36);
    const hashId = Math.abs(hash).toString(36);

    return `browser-${hashId}-${timestamp}`;
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    if (!validateField("otp", otp)) return;
    if (otp === generatedOtp) {
      notification.success({
        message: "Login Successful",
        description: "You have successfully logged in.",
      });
      history.push("/");
    } else {
      notification.error({
        message: "Error",
        description: "Invalid OTP",
      });
    }
  };

  const togglePasswordVisibility = () => {
    setEye(!eye);
  };

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src="/Name.png"
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Login</h1>
                  <p className="account-subtitle">
                    Login to access your dashboard securely and manage
                    everything in one place.
                  </p>
                  <div>
                    {!formHide ? (
                      <form onSubmit={handleSubmit}>
                        <div className="input-block mb-3 input_text">
                          <label className="form-control-label">
                            Email Address
                          </label>
                          <input
                            className={`form-control ${
                              errors.email ? "error-input" : ""
                            }`}
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="off"
                          />
                          {errors.email && <p>{errors.email}</p>}
                        </div>

                        <div className="input-block mb-3 input_text login-eye">
                          <label className="form-control-label">Password</label>
                          <div className="pass-group">
                            <input
                              type={eye ? "password" : "text"}
                              className={`form-control ${
                                errors.password ? "error-input" : ""
                              }`}
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              autoComplete="off"
                            />
                            <span
                              onClick={togglePasswordVisibility}
                              className={`fas toggle-password ${
                                eye ? "fa-eye-slash" : "fa-eye"
                              }`}
                            />
                          </div>
                          {errors.password && <p>{errors.password}</p>}
                        </div>

                        <button
                          className="btn btn-lg btn-block w-100 btn-primary"
                          type="submit"
                        >
                          Login
                        </button>
                      </form>
                    ) : (
                      <div className="opt-login">
                        {!otpSent ? (
                          <form onSubmit={handleEmailSubmit}>
                            <div className="input-block mb-3 input_text">
                              <label className="form-control-label">
                                Email Address
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="off"
                              />
                              {errors.email && <p>{errors.email}</p>}
                            </div>
                            <button
                              className="btn btn-lg btn-block w-100 btn-primary"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Sending OTP..." : "Get OTP"}
                            </button>
                          </form>
                        ) : (
                          <form onSubmit={handleOtpSubmit}>
                            <div className="input-block mb-3 input_text">
                              <label className="form-control-label">
                                One Time Password
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                autoComplete="off"
                              />
                            </div>
                            {errors.otp && <p>{errors.otp}</p>}
                            <p className="mb-3">
                              OPT is send your Register Whatsapp Number
                            </p>
                            <button
                              className="btn btn-lg btn-block w-100 btn-primary"
                              type="submit"
                            >
                              Login
                            </button>
                          </form>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <button className="btn btn-lg btn-block btn-danger w-75">
                <a href="#/user_dele" className="text-white">
                  Delete my phone account
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
